import { create } from "zustand";
import { persist } from "zustand/middleware";

interface NotificationContent {
	text: string;
}

type NotificationType = "ORDER_STATUS_UPDATE";
interface NotificationData {
	contractId: string;
	orderId: string;
	text: string;
	notificationType: NotificationType;
	userId: string;
}

export interface Notification {
	read?: boolean;
	timestamp: string;
	data: NotificationData;
	notification: NotificationContent;
}

interface NotificationState {
	notifications: Record<string, Notification[]>;
	addNotification: (notification: Notification) => void;
	markAsRead: (userId: string, timestamp: string) => void;
	getUserNotifications: (userId: string) => Notification[];
	getUnreadNotificationsCount: (userId: string) => number;

}

export const useNotificationStore = create<NotificationState>()(
	persist(
		(set, get) => ({
			notifications: {},

			getUserNotifications: (userId: string) => {
				const state = get();
				return state.notifications[userId] || [];
			},

			addNotification: (notification: Notification) => {
				set((state) => {
					const userId = notification.data.userId;
					const userNotifications = state.notifications[userId] || [];

					return {
						notifications: {
							...state.notifications,
							[userId]: [...userNotifications, { ...notification, read: false }]
						}
					};
				});
			},

			markAsRead: (userId: string, timestamp: string) => {
				if (!timestamp || !userId)
					return;

				set((state) => {
					const userNotifications = state.notifications[userId] || [];
					const updatedNotifications = userNotifications.map(notification =>
						notification.timestamp === timestamp
							? { ...notification, read: true }
							: notification
					);

					return {
						notifications: {
							...state.notifications,
							[userId]: updatedNotifications
						}
					};
				});
			},
			getUnreadNotificationsCount: (userId: string) => {
				const state = get();
				const userNotifications = state.notifications[userId] || [];
				return userNotifications.filter(notification => !notification.read).length;
			}
		}),
		{
			name: "intasida/notifications"
		}
	)
);
